module.exports = __webpack_public_path__ + "img/user.cc307c20.png";